import { useEffect, useState } from 'react'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'

export const PLAN_LIMIT_EVENT = 'plan-limit-reached'

export interface PlanLimitDetail {
  message: string
  limit: number
  current: number
}

export function dispatchPlanLimitEvent(detail: PlanLimitDetail) {
  window.dispatchEvent(new CustomEvent(PLAN_LIMIT_EVENT, { detail }))
}

export function PlanLimitModal() {
  const [open, setOpen] = useState(false)
  const [detail, setDetail] = useState<PlanLimitDetail | null>(null)

  useEffect(() => {
    function handler(e: Event) {
      const d = (e as CustomEvent<PlanLimitDetail>).detail
      setDetail(d)
      setOpen(true)
    }
    window.addEventListener(PLAN_LIMIT_EVENT, handler)
    return () => window.removeEventListener(PLAN_LIMIT_EVENT, handler)
  }, [])

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle className="text-amber-500">Límite del plan alcanzado</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-3">
          <p className="text-text-primary text-sm">{detail?.message}</p>
          {detail && (
            <p className="text-text-muted text-xs">
              Uso actual: <span className="font-semibold text-text-primary">{detail.current}</span> / {detail.limit}
            </p>
          )}
          <p className="text-text-muted text-xs">
            Contacta a soporte para ampliar tu plan y agregar más capacidad.
          </p>
          <Button
            variant="default"
            className="w-full"
            onClick={() => setOpen(false)}
          >
            Entendido
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
